










































































import { Vue, Component, Prop } from 'vue-property-decorator';

import TabGeneral from './tabs/TabGeneral.vue';
import TabDetalle from './tabs/TabDetalle.vue';
import TabEncomienda from './tabs/TabEncomienda.vue';

import { DataApi } from './models/Add.model';
import TabDispositivos from './tabs/TabDispositivos.vue';

@Component({
  components: {
    TabGeneral,
    TabDetalle,
    TabEncomienda,
    TabDispositivos,
  },
})
export default class AddModalVerDetalle extends Vue {
  @Prop({ default: true }) show: boolean;
  @Prop({ required: true, default: {} }) data!: DataApi;

  dialog: boolean = true;
  tabs: number = 0;

  handleClosed(): void {
    this.$emit('cerrar');
  }
}
